<template>
  <tabs parent="bank_payment_list">
    <tab id="payments" :name="translate('bank_payment.payments')" :href="url + '/payments'">
      <keep-alive>
        <Payments />
      </keep-alive>
    </tab>
    <tab id="imports" :name="translate('bank_payment.import_history.title')" :href="url + '/imports'">
      <Imports />
    </tab>
  </tabs>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Payments from './Tabs/Payments/Index.vue'
import Imports from './Tabs/Imports/Index.vue'

export default {
  name: 'BankPaymentList',
  components: {
    Tabs,
    Tab,
    Payments,
    Imports
  },
  computed: {
    url () { return '/bank_payment_list' }
  }
}
</script>
